import { useCallback, useRef } from 'react';
import { saveMessageLogs } from 'utils/forms/formLogging';

const useFormSubmissionLogging = () => {
  const logsRef = useRef([]);

  const addNewLog = useCallback((level, msg) => {
    logsRef.current.push({ level, msg });
  }, []);

  const getLogs = useCallback(() => logsRef.current, []);

  const clearLogs = useCallback(() => {
    logsRef.current = [];
  }, []);

  const saveLogs = useCallback(
    (logList, formData) =>
      Promise.resolve(saveMessageLogs(logList, formData)).then((result) => {
        clearLogs();
        return result;
      }),
    [clearLogs],
  );

  return {
    addNewLog,
    clearLogs,
    getLogs,
    saveLogs,
  };
};

export default useFormSubmissionLogging;
